export default __webpack_public_path__ + "static/media/map.54756efc.jpg";